import { render, staticRenderFns } from "./HBarChartCard.vue?vue&type=template&id=535d2448&scoped=true"
import script from "./HBarChartCard.vue?vue&type=script&lang=js"
export * from "./HBarChartCard.vue?vue&type=script&lang=js"
import style0 from "./HBarChartCard.vue?vue&type=style&index=0&id=535d2448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535d2448",
  null
  
)

export default component.exports